export type FeatureInterest = {
  email: string;
  features: string[];
  requestId: string;
  website: string;
};

export async function submitFeatureInterest(url: string, interest: FeatureInterest): Promise<void> {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 25000);
  try {
    // Form encoding avoids a CORS preflight; still require a readable JSON acknowledgement.
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'omit',
      body: new URLSearchParams({
        email: interest.email,
        features: JSON.stringify(interest.features),
        requestId: interest.requestId,
        website: interest.website,
      }),
      signal: controller.signal,
    });
    if (!response.ok) throw new Error('Submission failed');
    const result = await response.json();
    if (result.success !== true || result.requestId !== interest.requestId) {
      throw new Error('Save was not confirmed');
    }
  } finally {
    window.clearTimeout(timeout);
  }
}
